import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig } from '../types';

const driverBookConfig: TSPConfig = {
  key: 'driverbook',
  name: 'DriverBook',
  category: TSPCategory.API_KEY,
  helpText:
    'Enter your DriverBook API key and DOT number to connect your account.',
  loginComponent: (props: LoginComponentProps) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'API Key',
          name: 'apikey',
          type: 'text',
          required: true,
        },
        {
          label: 'DOT Number',
          name: 'dotnumber',
          type: 'number',
          required: true,
        },
      ]}
    />
  ),
};

export default driverBookConfig;
